class VideoPopupBtn extends HTMLElement {
  constructor() {
    super();
    this.togglePopup = this.togglePopup.bind(this);
    this.popup = null;
  }

  connectedCallback() {
    console.warn('togglePopup', this.querySelectorAll('.togglePopup'));
    this.querySelectorAll('.togglePopup').forEach((el) => {
      el.addEventListener('click', (event) => {
        console.log('click');
        if (event.target.tagName !== 'VIDEO') {
          this.togglePopup();
        }
      });
    });
    this.popup = this.querySelector('.popup');

    if (this.popup) {
      // 将 popup 移动到 body
      document.body.appendChild(this.popup);
    } else {
      console.error('Popup element not found.');
    }
  }

  disconnectedCallback() {
    if (this.popup && document.body.contains(this.popup)) {
      document.body.removeChild(this.popup); // 清理 popup 元素
    }
  }

  togglePopup() {
    if (!this.popup) return;

    const isHidden = this.popup.classList.contains('hidden-video-popup');

    if (isHidden) {
      this.showPopup();
    } else {
      this.hidePopup();
    }
  }

  showPopup() {
    if (!this.popup) return;

    this.popup.classList.remove('hidden-video-popup');
    gsap.fromTo(
      this.popup,
      { opacity: 0 },
      {
        opacity: 1,
        duration: 0.3,
        ease: 'linear',
        backdropFilter: 'blur(30px)',
        onComplete: () => {
          const video = this.popup.querySelector('video');
          if (video) {
            video.play();
          }
        },
      }
    );
  }

  hidePopup() {
    if (!this.popup) return;

    gsap.to(this.popup, {
      opacity: 0,
      duration: 0.3,
      ease: 'linear',
      onComplete: () => {
        this.popup.classList.add('hidden-video-popup');
        const video = this.popup.querySelector('video');
        if (video) {
          video.pause();
        }
      },
    });
  }
}

if (!customElements.get('video-popup-btn')) {
  customElements.define('video-popup-btn', VideoPopupBtn);
}
